var win=window;export var caf=win.cancelAnimationFrame||win.mozCancelAnimationFrame||function(id){clearTimeout(id);};